<div class="handles">
    <ng-content></ng-content>
    <app-handle (click)="close()">
        <i class="fa fa-times"></i>
    </app-handle>
</div>

@if (numeric) {
<svg
    version="1.1"
    class="svg"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="85 105 1059 568"
    style="enable-background: new 85 105 1059 568"
    xml:space="preserve"
>
    <g class="keyboard">
        <g id="background">
            <g>
                <path
                    class="keyboard-background"
                    d="M1148,656.5c0,8-6.5,14.5-14.5,14.5h-1030c-8,0-14.5-6.5-14.5-14.5v-539c0-8,6.5-14.5,14.5-14.5h1030c8,0,14.5,6.5,14.5,14.5V656.5z"
                />
            </g>
        </g>
        <g id="buttons">
            <g id="first-row">
                <g [id]="keysEnum.Num1" class="key" (click)="recordKey($event)">
                    <path
                        class="key-shadow"
                        d="M174.6,229.3h-65.2c-6.6,0-12-5.4-12-12v-92.4c0-6.6,5.4-12,12-12h65.2c6.6,0,12,5.4,12,12v92.4C186.6,223.9,181.2,229.3,174.6,229.3z"
                    />
                    <path
                        class="key-background"
                        d="M174.7,226.6h-65.5c-6.6,0-11.9-5.3-11.9-11.9v-90c0-6.6,5.3-11.9,11.9-11.9h65.5c6.6,0,11.9,5.3,11.9,11.9v90C186.6,221.3,181.2,226.6,174.7,226.6z"
                    />
                </g>
                <g [id]="keysEnum.Num2" class="key" (click)="recordKey($event)">
                    <path
                        class="key-shadow"
                        d="M280.4,229.3h-65.2c-6.6,0-12-5.4-12-12v-92.4c0-6.6,5.4-12,12-12h65.2c6.6,0,12,5.4,12,12v92.4C292.4,223.9,287,229.3,280.4,229.3z"
                    />
                    <path
                        class="key-background"
                        d="M280.5,226.6H215c-6.6,0-11.9-5.3-11.9-11.9v-90c0-6.6,5.3-11.9,11.9-11.9h65.5c6.6,0,11.9,5.3,11.9,11.9v90C292.4,221.3,287.1,226.6,280.5,226.6z"
                    />
                </g>
                <g [id]="keysEnum.Num3" class="key" (click)="recordKey($event)">
                    <path
                        class="key-shadow"
                        d="M386.3,229.3H321c-6.6,0-12-5.4-12-12v-92.4c0-6.6,5.4-12,12-12h65.2c6.6,0,12,5.4,12,12v92.4C398.3,223.9,392.9,229.3,386.3,229.3z"
                    />
                    <path
                        class="key-background"
                        d="M386.4,226.6h-65.5c-6.6,0-11.9-5.3-11.9-11.9v-90c0-6.6,5.3-11.9,11.9-11.9h65.5c6.6,0,11.9,5.3,11.9,11.9v90C398.3,221.3,393,226.6,386.4,226.6z"
                    />
                </g>
                <g [id]="keysEnum.Num4" class="key" (click)="recordKey($event)">
                    <path
                        class="key-shadow"
                        d="M492.1,229.3h-65.2c-6.6,0-12-5.4-12-12v-92.4c0-6.6,5.4-12,12-12h65.2c6.6,0,12,5.4,12,12v92.4C504.1,223.9,498.8,229.3,492.1,229.3z"
                    />
                    <path
                        class="key-background"
                        d="M492.3,226.6h-65.5c-6.6,0-11.9-5.3-11.9-11.9v-90c0-6.6,5.3-11.9,11.9-11.9h65.5c6.6,0,11.9,5.3,11.9,11.9v90C504.1,221.3,498.8,226.6,492.3,226.6z"
                    />
                </g>
                <g [id]="keysEnum.Num5" class="key" (click)="recordKey($event)">
                    <path
                        class="key-shadow"
                        d="M598,229.3h-65.2c-6.6,0-12-5.4-12-12v-92.4c0-6.6,5.4-12,12-12H598c6.6,0,12,5.4,12,12v92.4C610,223.9,604.6,229.3,598,229.3z"
                    />
                    <path
                        class="key-background"
                        d="M598.1,226.6h-65.5c-6.6,0-11.9-5.3-11.9-11.9v-90c0-6.6,5.3-11.9,11.9-11.9h65.5c6.6,0,11.9,5.3,11.9,11.9v90C610,221.3,604.7,226.6,598.1,226.6z"
                    />
                </g>
                <g [id]="keysEnum.Num6" class="key" (click)="recordKey($event)">
                    <path
                        class="key-shadow"
                        d="M703.8,229.3h-65.2c-6.6,0-12-5.4-12-12v-92.4c0-6.6,5.4-12,12-12h65.2c6.6,0,12,5.4,12,12v92.4C715.8,223.9,710.5,229.3,703.8,229.3z"
                    />
                    <path
                        class="key-background"
                        d="M704,226.6h-65.5c-6.6,0-11.9-5.3-11.9-11.9v-90c0-6.6,5.3-11.9,11.9-11.9H704c6.6,0,11.9,5.3,11.9,11.9v90C715.8,221.3,710.5,226.6,704,226.6z"
                    />
                </g>
                <g [id]="keysEnum.Num7" class="key" (click)="recordKey($event)">
                    <path
                        class="key-shadow"
                        d="M809.7,229.3h-65.2c-6.6,0-12-5.4-12-12v-92.4c0-6.6,5.4-12,12-12h65.2c6.6,0,12,5.4,12,12v92.4C821.7,223.9,816.3,229.3,809.7,229.3z"
                    />
                    <path
                        class="key-background"
                        d="M809.8,226.6h-65.5c-6.6,0-11.9-5.3-11.9-11.9v-90c0-6.6,5.3-11.9,11.9-11.9h65.5c6.6,0,11.9,5.3,11.9,11.9v90C821.7,221.3,816.4,226.6,809.8,226.6z"
                    />
                </g>
                <g [id]="keysEnum.Num8" class="key" (click)="recordKey($event)">
                    <path
                        class="key-shadow"
                        d="M915.5,229.3h-65.2c-6.6,0-12-5.4-12-12v-92.4c0-6.6,5.4-12,12-12h65.2c6.6,0,12,5.4,12,12v92.4C927.6,223.9,922.2,229.3,915.5,229.3z"
                    />
                    <path
                        class="key-background"
                        d="M915.7,226.6h-65.5c-6.6,0-11.9-5.3-11.9-11.9v-90c0-6.6,5.3-11.9,11.9-11.9h65.5c6.6,0,11.9,5.3,11.9,11.9v90C927.6,221.3,922.2,226.6,915.7,226.6z"
                    />
                </g>
                <g [id]="keysEnum.Num9" class="key" (click)="recordKey($event)">
                    <path
                        class="key-shadow"
                        d="M1021.4,229.3h-65.2c-6.6,0-12-5.4-12-12v-92.4c0-6.6,5.4-12,12-12h65.2c6.6,0,12,5.4,12,12v92.4C1033.4,223.9,1028,229.3,1021.4,229.3z"
                    />
                    <path
                        class="key-background"
                        d="M1021.5,226.6H956c-6.6,0-11.9-5.3-11.9-11.9v-90c0-6.6,5.3-11.9,11.9-11.9h65.5c6.6,0,11.9,5.3,11.9,11.9v90C1033.4,221.3,1028.1,226.6,1021.5,226.6z"
                    />
                </g>
                <g [id]="keysEnum.Num0" class="key" (click)="recordKey($event)">
                    <path
                        class="key-shadow"
                        d="M1127.3,229.3H1062c-6.6,0-12-5.4-12-12v-92.4c0-6.6,5.4-12,12-12h65.2c6.6,0,12,5.4,12,12v92.4C1139.3,223.9,1133.9,229.3,1127.3,229.3z"
                    />
                    <path
                        class="key-background"
                        d="M1127.4,226.6h-65.5c-6.6,0-11.9-5.3-11.9-11.9v-90c0-6.6,5.3-11.9,11.9-11.9h65.5c6.6,0,11.9,5.3,11.9,11.9v90C1139.3,221.3,1134,226.6,1127.4,226.6z"
                    />
                </g>
            </g>
            <g id="second-row">
                <g
                    [id]="keysEnum.Hyphen"
                    class="key"
                    (click)="recordKey($event)"
                >
                    <path
                        class="key-shadow"
                        d="M174.6,375.3h-65.2c-6.6,0-12-5.4-12-12V271c0-6.6,5.4-12,12-12h65.2c6.6,0,12,5.4,12,12v92.4C186.6,370,181.2,375.3,174.6,375.3z"
                    />
                    <path
                        class="key-background"
                        d="M174.7,372.6h-65.5c-6.6,0-11.9-5.3-11.9-11.9v-90c0-6.6,5.3-11.9,11.9-11.9h65.5c6.6,0,11.9,5.3,11.9,11.9v90C186.6,367.3,181.3,372.6,174.7,372.6z"
                    />
                </g>
                <g
                    [id]="keysEnum.ForwardSlash"
                    class="key"
                    (click)="recordKey($event)"
                >
                    <path
                        class="key-shadow"
                        d="M280.6,375.3h-65.2c-6.6,0-12-5.4-12-12V271c0-6.6,5.4-12,12-12h65.2c6.6,0,12,5.4,12,12v92.4C292.6,370,287.3,375.3,280.6,375.3z"
                    />
                    <path
                        class="key-background"
                        d="M280.8,372.6h-65.5c-6.6,0-11.9-5.3-11.9-11.9v-90c0-6.6,5.3-11.9,11.9-11.9h65.5c6.6,0,11.9,5.3,11.9,11.9v90C292.6,367.3,287.3,372.6,280.8,372.6z"
                    />
                </g>
                <g
                    [id]="keysEnum.Colon"
                    class="key"
                    (click)="recordKey($event)"
                >
                    <path
                        class="key-shadow"
                        d="M386.3,375.3h-65.2c-6.6,0-12-5.4-12-12V271c0-6.6,5.4-12,12-12h65.2c6.6,0,12,5.4,12,12v92.4C398.3,370,392.9,375.3,386.3,375.3z"
                    />
                    <path
                        class="key-background"
                        d="M386.4,372.6h-65.5c-6.6,0-11.9-5.3-11.9-11.9v-90c0-6.6,5.3-11.9,11.9-11.9h65.5c6.6,0,11.9,5.3,11.9,11.9v90C398.3,367.3,393,372.6,386.4,372.6z"
                    />
                </g>
                <g
                    [id]="keysEnum.Semicolon"
                    class="key"
                    (click)="recordKey($event)"
                >
                    <path
                        class="key-shadow"
                        d="M492.3,375.3h-65.2c-6.6,0-12-5.4-12-12V271c0-6.6,5.4-12,12-12h65.2c6.6,0,12,5.4,12,12v92.4C504.4,370,499,375.3,492.3,375.3z"
                    />
                    <path
                        class="key-background"
                        d="M492.5,372.6H427c-6.6,0-11.9-5.3-11.9-11.9v-90c0-6.6,5.3-11.9,11.9-11.9h65.5c6.6,0,11.9,5.3,11.9,11.9v90C504.4,367.3,499,372.6,492.5,372.6z"
                    />
                </g>
                <g
                    [id]="keysEnum.OpenBracket"
                    class="key"
                    (click)="recordKey($event)"
                >
                    <path
                        class="key-shadow"
                        d="M600,375.3h-65.2c-6.6,0-12-5.4-12-12V271c0-6.6,5.4-12,12-12H600c6.6,0,12,5.4,12,12v92.4C612,370,606.6,375.3,600,375.3z"
                    />
                    <path
                        class="key-background"
                        d="M600.1,372.6h-65.5c-6.6,0-11.9-5.3-11.9-11.9v-90c0-6.6,5.3-11.9,11.9-11.9h65.5c6.6,0,11.9,5.3,11.9,11.9v90C612,367.3,606.7,372.6,600.1,372.6z"
                    />
                </g>
                <g
                    [id]="keysEnum.CloseBracket"
                    class="key"
                    (click)="recordKey($event)"
                >
                    <path
                        class="key-shadow"
                        d="M705.3,375.3H640c-6.6,0-12-5.4-12-12V271c0-6.6,5.4-12,12-12h65.2c6.6,0,12,5.4,12,12v92.4C717.3,370,711.9,375.3,705.3,375.3z"
                    />
                    <path
                        class="key-background"
                        d="M705.4,372.6h-65.5c-6.6,0-11.9-5.3-11.9-11.9v-90c0-6.6,5.3-11.9,11.9-11.9h65.5c6.6,0,11.9,5.3,11.9,11.9v90C717.3,367.3,712,372.6,705.4,372.6z"
                    />
                </g>
                <g [id]="keysEnum.Euro" class="key" (click)="recordKey($event)">
                    <path
                        class="key-shadow"
                        d="M811.3,375.3h-65.2c-6.6,0-12-5.4-12-12V271c0-6.6,5.4-12,12-12h65.2c6.6,0,12,5.4,12,12v92.4C823.3,370,818,375.3,811.3,375.3z"
                    />
                    <path
                        class="key-background"
                        d="M811.5,372.6h-65.5c-6.6,0-11.9-5.3-11.9-11.9v-90c0-6.6,5.3-11.9,11.9-11.9h65.5c6.6,0,11.9,5.3,11.9,11.9v90C823.3,367.3,818,372.6,811.5,372.6z"
                    />
                </g>
                <g
                    [id]="keysEnum.Ampersand"
                    class="key"
                    (click)="recordKey($event)"
                >
                    <path
                        class="key-shadow"
                        d="M917.2,375.3h-65.2c-6.6,0-12-5.4-12-12V271c0-6.6,5.4-12,12-12h65.2c6.6,0,12,5.4,12,12v92.4C929.2,370,923.8,375.3,917.2,375.3z"
                    />
                    <path
                        class="key-background"
                        d="M917.3,372.6h-65.5c-6.6,0-11.9-5.3-11.9-11.9v-90c0-6.6,5.3-11.9,11.9-11.9h65.5c6.6,0,11.9,5.3,11.9,11.9v90C929.2,367.3,923.9,372.6,917.3,372.6z"
                    />
                </g>
                <g
                    [id]="keysEnum.AtSign"
                    class="key"
                    (click)="recordKey($event)"
                >
                    <path
                        class="key-shadow"
                        d="M1023,375.3h-65.2c-6.6,0-12-5.4-12-12V271c0-6.6,5.4-12,12-12h65.2c6.6,0,12,5.4,12,12v92.4C1035,370,1029.7,375.3,1023,375.3z"
                    />
                    <path
                        class="key-background"
                        d="M1023.2,372.6h-65.5c-6.6,0-11.9-5.3-11.9-11.9v-90c0-6.6,5.3-11.9,11.9-11.9h65.5c6.6,0,11.9,5.3,11.9,11.9v90C1035,367.3,1029.7,372.6,1023.2,372.6z"
                    />
                </g>
                <g
                    [id]="keysEnum.DoubleQuote"
                    class="key"
                    (click)="recordKey($event)"
                >
                    <path
                        class="key-shadow"
                        d="M1126.3,373.9h-65.2c-6.6,0-12-5.4-12-12v-92.4c0-6.6,5.4-12,12-12h65.2c6.6,0,12,5.4,12,12v92.4C1138.3,368.6,1133,373.9,1126.3,373.9z"
                    />
                    <path
                        class="key-background"
                        d="M1126.5,371.2h-65.5c-6.6,0-11.9-5.3-11.9-11.9v-90c0-6.6,5.3-11.9,11.9-11.9h65.5c6.6,0,11.9,5.3,11.9,11.9v90C1138.3,365.9,1133,371.2,1126.5,371.2z"
                    />
                </g>
            </g>
            <g id="third-row">
                <g [id]="keysEnum.Shift" class="key" (click)="toggleShift()">
                    <path
                        class="key-shadow"
                        d="M202.1,521.9h-90.9c-7.7,0-13.9-6.2-13.9-13.9v-88.4c0-7.7,6.2-13.9,13.9-13.9h90.9c7.7,0,13.9,6.2,13.9,13.9V508C216,515.7,209.8,521.9,202.1,521.9z"
                    />
                    <path
                        class="action-key"
                        [class.active]="shift"
                        d="M202.2,519.5h-91.2c-7.6,0-13.8-6.2-13.8-13.8v-86.3c0-7.6,6.2-13.8,13.8-13.8h91.2c7.6,0,13.8,6.2,13.8,13.8v86.3C216,513.3,209.9,519.5,202.2,519.5z"
                    />
                    <path
                        class="symbol-key"
                        [class.active]="shift"
                        d="M175.4,490.8c0,3.4-2.8,6.2-6.2,6.2H142c-3.4,0-6.2-2.8-6.2-6.2v-17.9h-9.3c-2.2,0-4.2-1.3-5.1-3.4c-0.9-2.1-0.4-4.4,1.2-6l33-33l33,33c1.6,1.6,2,3.9,1.2,6c-0.9,2.1-2.9,3.4-5.1,3.4h-9.3V490.8z M127.7,466.9h14v23.9c0,0.1,0.1,0.2,0.2,0.2h27.3c0.1,0,0.2-0.1,0.2-0.2v-23.9h14L155.6,439L127.7,466.9z"
                    />
                </g>
                <g
                    [id]="keysEnum.Backspace"
                    class="key"
                    (click)="recordKey($event)"
                >
                    <path
                        class="key-shadow"
                        d="M1125.2,521.9h-90.9c-7.7,0-13.9-6.2-13.9-13.9v-88.4c0-7.7,6.2-13.9,13.9-13.9h90.9c7.7,0,13.9,6.2,13.9,13.9V508C1139.1,515.7,1132.9,521.9,1125.2,521.9z"
                    />
                    <path
                        class="action-key"
                        d="M1125.3,519.5h-91.2c-7.6,0-13.8-6.2-13.8-13.8v-86.3c0-7.6,6.2-13.8,13.8-13.8h91.2c7.6,0,13.8,6.2,13.8,13.8v86.3C1139.1,513.3,1132.9,519.5,1125.3,519.5z"
                    />
                    <path
                        class="symbol-key"
                        d="M1112,441c0-1.1-0.9-2-2-2h-44.3c-0.7,0-1.3,0.3-1.7,0.9l-14.4,22.1l14.4,22.1c0.4,0.6,1,0.9,1.7,0.9h44.3c1.1,0,2-0.9,2-2V441z M1110,433c4.4,0,8,3.6,8,8v42c0,4.4-3.6,8-8,8h-44.3c-2.7,0-5.2-1.4-6.7-3.6l-16.6-25.4l16.6-25.4c1.5-2.3,4-3.6,6.7-3.6H1110z M1097.4,453.7l-8.3,8.3l8.3,8.3c1.2,1.2,1.2,3.1,0,4.2c-0.6,0.6-1.4,0.9-2.1,0.9c-0.8,0-1.5-0.3-2.1-0.9l-8.3-8.3l-8.3,8.3c-0.6,0.6-1.4,0.9-2.1,0.9c-0.8,0-1.5-0.3-2.1-0.9c-1.2-1.2-1.2-3.1,0-4.2l8.3-8.3l-8.3-8.3c-1.2-1.2-1.2-3.1,0-4.2c1.2-1.2,3.1-1.2,4.2,0l8.3,8.3l8.3-8.3c1.2-1.2,3.1-1.2,4.2,0C1098.6,450.7,1098.6,452.6,1097.4,453.7z"
                    />
                </g>
                <g
                    [id]="keysEnum.Period"
                    class="key"
                    (click)="recordKey($event)"
                >
                    <path
                        class="key-shadow"
                        d="M394.1,521.9h-90.9c-7.7,0-13.9-6.2-13.9-13.9v-88.4c0-7.7,6.2-13.9,13.9-13.9h90.9c7.7,0,13.9,6.2,13.9,13.9V508C408,515.7,401.8,521.9,394.1,521.9z"
                    />
                    <path
                        class="key-background"
                        d="M394.2,519.5h-91.2c-7.6,0-13.8-6.2-13.8-13.8v-86.3c0-7.6,6.2-13.8,13.8-13.8h91.2c7.6,0,13.8,6.2,13.8,13.8v86.3C408,513.3,401.9,519.5,394.2,519.5z"
                    />
                </g>
                <g
                    [id]="keysEnum.Comma"
                    class="key"
                    (click)="recordKey($event)"
                >
                    <path
                        class="key-shadow"
                        d="M529.1,521.9h-90.9c-7.7,0-13.9-6.2-13.9-13.9v-88.4c0-7.7,6.2-13.9,13.9-13.9h90.9c7.7,0,13.9,6.2,13.9,13.9V508C543,515.7,536.8,521.9,529.1,521.9z"
                    />
                    <path
                        class="key-background"
                        d="M529.2,519.5h-91.2c-7.6,0-13.8-6.2-13.8-13.8v-86.3c0-7.6,6.2-13.8,13.8-13.8h91.2c7.6,0,13.8,6.2,13.8,13.8v86.3C543,513.3,536.9,519.5,529.2,519.5z"
                    />
                </g>
                <g
                    [id]="keysEnum.QuestionMark"
                    class="key"
                    (click)="recordKey($event)"
                >
                    <path
                        class="key-shadow"
                        d="M664.1,521.9h-90.9c-7.7,0-13.9-6.2-13.9-13.9v-88.4c0-7.7,6.2-13.9,13.9-13.9h90.9c7.7,0,13.9,6.2,13.9,13.9V508C678,515.7,671.8,521.9,664.1,521.9z"
                    />
                    <path
                        class="key-background"
                        d="M664.2,519.5h-91.2c-7.6,0-13.8-6.2-13.8-13.8v-86.3c0-7.6,6.2-13.8,13.8-13.8h91.2c7.6,0,13.8,6.2,13.8,13.8v86.3C678,513.3,671.9,519.5,664.2,519.5z"
                    />
                </g>
                <g
                    [id]="keysEnum.ExclamationMark"
                    class="key"
                    (click)="recordKey($event)"
                >
                    <path
                        class="key-shadow"
                        d="M799.1,521.9h-90.9c-7.7,0-13.9-6.2-13.9-13.9v-88.4c0-7.7,6.2-13.9,13.9-13.9h90.9c7.7,0,13.9,6.2,13.9,13.9V508C813,515.7,806.8,521.9,799.1,521.9z"
                    />
                    <path
                        class="key-background"
                        d="M799.2,519.5h-91.2c-7.6,0-13.8-6.2-13.8-13.8v-86.3c0-7.6,6.2-13.8,13.8-13.8h91.2c7.6,0,13.8,6.2,13.8,13.8v86.3C813,513.3,806.9,519.5,799.2,519.5z"
                    />
                </g>
                <g
                    [id]="keysEnum.Apostrophe"
                    class="key"
                    (click)="recordKey($event)"
                >
                    <path
                        class="key-shadow"
                        d="M934.1,521.9h-90.9c-7.7,0-13.9-6.2-13.9-13.9v-88.4c0-7.7,6.2-13.9,13.9-13.9h90.9c7.7,0,13.9,6.2,13.9,13.9V508C948,515.7,941.8,521.9,934.1,521.9z"
                    />
                    <path
                        class="key-background"
                        d="M934.2,519.5h-91.2c-7.6,0-13.8-6.2-13.8-13.8v-86.3c0-7.6,6.2-13.8,13.8-13.8h91.2c7.6,0,13.8,6.2,13.8,13.8v86.3C948,513.3,941.9,519.5,934.2,519.5z"
                    />
                </g>
            </g>
            <g id="forth-row">
                <g
                    [id]="keysEnum.Space"
                    class="key"
                    (click)="recordKey($event)"
                >
                    <path
                        class="key-shadow"
                        d="M860.2,546.1H524H482H373.4c-6.6,0-12,5.4-12,12v92.4c0,6.6,5.4,12,12,12H482H524h336.2c8.4,0,15.1-6.8,15.1-15.1v-86.1C875.3,552.8,868.6,546.1,860.2,546.1z"
                    />
                    <path
                        class="key-background"
                        d="M860.5,546.1H573.1h-91.4H373.3c-6.6,0-11.9,5.3-11.9,11.9v90c0,6.6,5.3,11.9,11.9,11.9h108.5h91.4h287.4c8.2,0,14.8-6.6,14.8-14.8v-84C875.3,552.7,868.7,546.1,860.5,546.1z"
                    />
                </g>
                <g
                    [id]="keysEnum.Enter"
                    class="key"
                    (click)="recordKey($event)"
                >
                    <path
                        class="key-shadow"
                        d="M1127.3,662.5H903.9c-6.5,0-11.8-5.3-11.8-11.8v-92.9c0-6.5,5.3-11.8,11.8-11.8h223.5c6.5,0,11.8,5.3,11.8,11.8v92.9C1139.1,657.2,1133.8,662.5,1127.3,662.5z"
                    />
                    <path
                        class="action-key"
                        d="M1127.6,659.8H903.6c-6.4,0-11.5-5.2-11.5-11.5v-90.6c0-6.4,5.2-11.5,11.5-11.5h223.9c6.4,0,11.5,5.2,11.5,11.5v90.6C1139.1,654.6,1133.9,659.8,1127.6,659.8z"
                    />
                    <path
                        class="symbol-key"
                        d="M1003.2,607l9.9,9.9l-4.2,4.2L991.8,604l17.1-17.1l4.2,4.2l-9.9,9.9h38.8v-12h6v18H1003.2z"
                    />
                </g>
                <g id="toggleLetters" class="key" (click)="toggleNumeric()">
                    <path
                        class="action-key"
                        d="M331.1,546.1H199.6c-0.2,0-0.3,0-0.5,0c-0.2,0-0.3,0-0.5,0h-87.7c-7.5,0-13.6,6.1-13.6,13.6v86.7     c0,7.5,6.1,13.6,13.6,13.6h87.7c0.2,0,0.3,0,0.5,0c0.2,0,0.3,0,0.5,0h131.5c7.5,0,13.6-6.1,13.6-13.6v-86.7     C344.6,552.2,338.6,546.1,331.1,546.1z"
                    />
                    <path
                        class="symbol-key"
                        d="M203.2,620.7c-2.4,2.6-5.7,4-9.6,4c-4.9,0-10.1-3.3-10.1-9.6c0-6.5,5.2-9.5,10.1-9.5c4,0,7.3,1.3,9.6,4      v-5.2c0-3.9-3.1-6.1-7.3-6.1c-3.5,0-6.3,1.3-8.9,4l-2.1-3.1c3.1-3.2,6.8-4.8,11.6-4.8c6.1,0,11.2,2.8,11.2,9.8V624h-4.5V620.7z       M203.2,612.4c-1.7-2.4-4.8-3.6-8-3.6c-4.2,0-7.1,2.6-7.1,6.4c0,3.7,2.9,6.3,7.1,6.3c3.2,0,6.2-1.2,8-3.6V612.4z"
                    />
                    <path
                        class="symbol-key"
                        d="M216.7,584h4.5v15.4c2.3-3.2,5.8-5.1,9.8-5.1c7.6,0,12.9,6,12.9,15.2c0,9.4-5.3,15.2-12.9,15.2      c-4.1,0-7.6-2.1-9.8-5v4.3h-4.5V584z M229.8,620.7c5.9,0,9.4-4.7,9.4-11.2s-3.5-11.2-9.4-11.2c-3.5,0-7.1,2.2-8.6,4.7v13.1      C222.8,618.7,226.3,620.7,229.8,620.7z"
                    />
                    <path
                        class="symbol-key"
                        d="M264,594.3c5.3,0,8.4,2.2,10.6,5l-3,2.8c-1.9-2.6-4.4-3.8-7.4-3.8c-6.2,0-10,4.7-10,11.2s3.8,11.2,10,11.2      c3,0,5.5-1.2,7.4-3.8l3,2.8c-2.2,2.9-5.3,5-10.6,5c-8.6,0-14.5-6.6-14.5-15.2C249.5,600.9,255.3,594.3,264,594.3z"
                    />
                </g>
            </g>
            <g id="symbols">
                <g>
                    <path
                        class="letter"
                        d="M142.2,151.8l-8.6,9l-4-4.1L143,143h5.8v53.4h-6.6V151.8z"
                    />
                </g>
                <g>
                    <path
                        class="letter"
                        d="M229.3,191.1c19.2-15.1,29.6-24,29.6-33.2c0-6.8-5.6-9.8-11.1-9.8c-6.4,0-11.4,2.7-14.5,6.7l-4.1-4.2      c4.1-5.4,11-8.4,18.6-8.4c8.9,0,17.9,5,17.9,15.7c0,10.9-11,20.8-25.9,32.6h26.2v5.9h-36.6V191.1z"
                    />
                </g>
                <g>
                    <path
                        class="letter"
                        d="M337.5,184.4c3.1,4.2,8.6,7,14.9,7c7.8,0,12.5-3.8,12.5-10c0-6.6-5.4-9.4-13.3-9.4c-2.2,0-4.7,0-5.5,0.1V166      c0.9,0.1,3.4,0.1,5.5,0.1c6.7,0,12.4-2.6,12.4-8.8c0-5.9-5.4-9.1-11.9-9.1c-5.8,0-10.2,2.2-14.1,6.5l-3.7-4.2      c3.8-4.6,10-8.2,18.2-8.2c10.2,0,18.1,5.2,18.1,14.2c0,7.7-6.5,11.5-11.5,12.4c4.9,0.4,12.3,4.6,12.3,13.1      c0,8.9-7.1,15.4-18.9,15.4c-9,0-15.7-4-19-8.8L337.5,184.4z"
                    />
                </g>
                <g>
                    <path
                        class="letter"
                        d="M465.1,182.8h-25.4v-5.5l22.9-34.3h9.1v34h7.5v5.8h-7.5v13.5h-6.6V182.8z M446.4,177h18.7v-27.8L446.4,177z"
                    />
                </g>
                <g>
                    <path
                        class="letter"
                        d="M551.3,184.4c3.5,4.5,8.2,7,14.7,7c7.3,0,12.3-5,12.3-11.4c0-7-5-11.5-12.2-11.5c-4.7,0-8.7,1.5-12.3,5l-4.9-1.7V143      h32.6v5.9h-26v18.6c2.6-2.6,7.1-4.8,12.5-4.8c8.9,0,17,6.1,17,17c0,10.9-8.2,17.6-19,17.6c-9,0-14.8-3.3-18.8-8.6L551.3,184.4z"
                    />
                </g>
                <g>
                    <path
                        class="letter"
                        d="M673.6,142.2c6.9,0,11.5,2.6,14.8,6.4l-3.4,5c-2.7-3.2-5.8-5.4-11.4-5.4c-10.3,0-15,10.5-15,21c0,0.7,0,1.4,0.1,2.1      c2.3-3.7,8.2-8.3,15.1-8.3c9.6,0,17.4,5.7,17.4,17c0,9.3-7,17.4-18.7,17.4c-14.9,0-20.6-13-20.6-27.5S658.7,142.2,673.6,142.2z       M672.2,168.6c-5.3,0-10.4,3.3-13.4,8c0.6,6.6,4.2,14.8,13.4,14.8c8.2,0,12.2-6.2,12.2-11.3      C684.5,172.3,679.1,168.6,672.2,168.6z"
                    />
                </g>
                <g>
                    <path
                        class="letter"
                        d="M788.1,148.9h-28.7V143h36.4v4.6l-21.8,48.8h-7.4L788.1,148.9z"
                    />
                </g>
                <g>
                    <path
                        class="letter"
                        d="M877.1,168.8c-6.2-1.8-11.8-5.8-11.8-12.8c0-9.6,9.4-13.8,18.2-13.8c8.8,0,18.3,4.2,18.3,13.8c0,7-5.8,11-11.9,12.8      c6.6,2,12.7,6.9,12.7,14c0,9-8.6,14.5-19.1,14.5c-10.6,0-19.1-5.4-19.1-14.5C864.4,175.7,870.5,170.8,877.1,168.8z M883.5,171.8      c-3.3,0.4-12.5,3.4-12.5,10.3c0,5.8,5.8,9.3,12.5,9.3c6.6,0,12.4-3.5,12.4-9.3C895.9,175.2,886.8,172.2,883.5,171.8z       M883.5,148.1c-6.5,0-11.6,3.3-11.6,8.8c0,6.5,8.4,8.6,11.6,9.2c3.3-0.6,11.6-2.7,11.6-9.2C895.1,151.4,889.9,148.1,883.5,148.1      z"
                    />
                </g>
                <g>
                    <path
                        class="letter"
                        d="M974.9,185.9c2.7,3.2,5.9,5.4,11.4,5.4c10.8,0,15-10.8,15-20.9c0-0.7,0-1.4-0.1-2.2c-2.3,3.7-8.2,8.3-15,8.3      c-9.6,0-17.5-5.7-17.5-17c0-9.2,7-17.4,18.6-17.4c15,0,20.6,13,20.6,27.6c0,14.4-6.7,27.5-21.7,27.5c-6.8,0-11.4-2.6-14.8-6.4      L974.9,185.9z M987.7,148c-8.2,0-12.2,6.2-12.2,11.3c0,7.8,5.4,11.5,12.3,11.5c5.3,0,10.5-3.2,13.3-7.9      C1000.5,156.3,997,148,987.7,148z"
                    />
                </g>
                <g>
                    <path
                        class="letter"
                        d="M1094.5,142.2c14.6,0,20.4,14.5,20.4,27.5c0,13-5.8,27.6-20.4,27.6c-14.6,0-20.4-14.6-20.4-27.6      C1074.1,156.7,1079.9,142.2,1094.5,142.2z M1094.5,148.1c-10.2,0-13.6,11-13.6,21.6s3.4,21.7,13.6,21.7s13.6-11,13.6-21.7      S1104.7,148.1,1094.5,148.1z"
                    />
                </g>
                <g>
                    <path
                        class="letter"
                        d="M131.4,319.4h19.2v5.3h-19.2V319.4z"
                    />
                </g>
                <g>
                    <path
                        class="letter"
                        d="M255.6,286.4h4.7l-19,56.6h-4.7L255.6,286.4z"
                    />
                </g>
                <g>
                    <path
                        class="letter"
                        d="M354,302.2c2.4,0,4.4,2,4.4,4.4s-2,4.4-4.4,4.4s-4.4-2-4.4-4.4S351.6,302.2,354,302.2z M354,333.4c2.4,0,4.4,2,4.4,4.4      s-2,4.4-4.4,4.4s-4.4-2-4.4-4.4S351.6,333.4,354,333.4z"
                    />
                </g>
                <g>
                    <path
                        class="letter"
                        d="M454.9,349c2.6-1.7,4.9-4.8,5.2-7.4c-0.2,0.1-0.7,0.2-1.1,0.2c-2.2,0-3.8-1.7-3.8-4.1c0-2.3,1.8-4.3,4.2-4.3      c2.6,0,5,2.2,5,6.1c0,4.9-2.9,9.4-6.6,12.1L454.9,349z M455.1,306.6c0-2.4,2-4.4,4.4-4.4s4.4,2,4.4,4.4c0,2.3-2,4.4-4.4,4.4      S455.1,308.9,455.1,306.6z"
                    />
                </g>
                <g>
                    <path
                        class="letter"
                        d="M561.1,316.9c0-12.9,4.1-25.4,11.3-35.4l3.6,2.7c-5.1,10.2-8.3,19.3-8.3,32.6c0,13.3,3.2,22.5,8.3,32.6l-3.6,2.8      C565.2,342.4,561.1,329.8,561.1,316.9z"
                    />
                </g>
                <g>
                    <path
                        class="letter"
                        d="M664.4,284.3l3.6-2.7c7.3,9.9,11.4,22.5,11.4,35.4s-4.1,25.5-11.4,35.4l-3.6-2.8c5.2-10.1,8.4-19.3,8.4-32.6      C672.8,303.6,669.6,294.4,664.4,284.3z"
                    />
                </g>
                <g>
                    <path
                        class="letter"
                        d="M798.1,328.6l5.6,3.1c-4.5,6.1-10.8,10.6-20.3,10.6c-12.8,0-23.4-7.8-26.5-19.9h-4.2v-4.2h3.5c-0.2-1.1-0.2-2.3-0.2-3.5      c0-1.3,0.1-2.5,0.2-3.7h-3.5v-4.2h4.3c3.1-12,13.7-19.8,26.4-19.8c9.5,0,16,4.6,20.3,10.6l-5.6,3.1c-3-4.5-8.6-7.8-14.7-7.8      c-9,0-16.5,5.4-19.3,13.8h24.2v4.2h-25.2c-0.2,1.2-0.2,2.4-0.2,3.7c0,1.2,0.1,2.4,0.2,3.5h25.2v4.2h-24.2      c2.7,8.5,10.2,14,19.3,14C789.5,336.4,795.1,333.2,798.1,328.6z"
                    />
                </g>
                <g>
                    <path
                        class="letter"
                        d="M907.3,341.4h-8.2c-1.6-1.4-3.7-3.4-5.8-5.6c-3.9,3.8-9,6.6-15.4,6.6c-9.1,0-16.6-5-16.6-14.9c0-8.3,5.6-12.6,11.8-15.9      c-2.4-4.1-4.1-8.2-4.1-11.9c0-7.1,5.8-12.4,13.4-12.4c6.9,0,12.1,3.8,12.1,10.5c0,8-6.9,11.5-13.6,15c2.1,3,4.4,5.6,6.2,7.6      c2.2,2.5,4.2,4.8,6.3,7.1c2.9-4.4,4.8-9.2,5.8-12.2l5.1,2.2c-1.8,4.2-4,9.3-7.2,13.8C900.1,334.6,903.5,337.8,907.3,341.4z       M889.6,332.1c-3-3.2-5.9-6.2-7.4-8.1c-2.2-2.6-4.5-5.4-6.6-8.5c-4.5,2.7-7.9,6-7.9,11.5c0,6.6,5.1,10.3,10.7,10.3      C882.8,337.4,886.6,335.1,889.6,332.1z M878.3,308.9c5.7-2.9,10.6-5.7,10.6-11c0-3.9-2.7-6-6.2-6c-4.2,0-7.5,3.2-7.5,7.8      C875.1,302.5,876.4,305.7,878.3,308.9z"
                    />
                </g>
                <g>
                    <path
                        class="letter"
                        d="M348.5,480.4c2.4,0,4.4,2,4.4,4.4c0,2.4-2,4.4-4.4,4.4s-4.4-2-4.4-4.4C344.1,482.4,346.1,480.4,348.5,480.4z"
                    />
                </g>
                <g>
                    <path
                        class="letter"
                        d="M479.4,496c2.6-1.7,4.9-4.8,5.2-7.4c-0.2,0.1-0.7,0.2-1.1,0.2c-2.2,0-3.8-1.7-3.8-4.1c0-2.3,1.8-4.3,4.2-4.3      c2.6,0,5,2.2,5,6.1c0,4.9-2.9,9.4-6.6,12.1L479.4,496z"
                    />
                </g>
                <g>
                    <path
                        class="letter"
                        d="M619.8,456.3c3.5-2.4,6.8-4.6,6.8-8.7c0-4-3.1-7.4-9.4-7.4c-6,0-9.8,2.6-12.7,6.6l-4-4.3c3.8-5,9.8-8.2,17.4-8.2      c9.8,0,15.7,5.5,15.7,12.4c0,6.7-4.7,10-9,13c-3.4,2.4-6.6,4.5-6.6,8c0,1.3,0.8,2.9,2.2,3.9l-4.9,2.1c-2.2-1.8-3.1-4.1-3.1-6.5      C612.1,461.7,616.1,458.9,619.8,456.3z M616.9,480.4c2.4,0,4.4,2,4.4,4.4c0,2.4-2,4.4-4.4,4.4c-2.4,0-4.4-2-4.4-4.4      C612.5,482.4,614.5,480.4,616.9,480.4z"
                    />
                </g>
                <g>
                    <path
                        class="letter"
                        d="M759.5,480.4c2.4,0,4.4,2,4.4,4.4c0,2.3-2,4.4-4.4,4.4c-2.4,0-4.4-2.1-4.4-4.4C755.1,482.4,757.1,480.4,759.5,480.4z       M755.7,435h7.5l-1.3,38.4h-5L755.7,435z"
                    />
                </g>
                <g>
                    <path
                        class="letter"
                        d="M881.4,449.9c2.6-1.7,4.9-4.9,5.2-7.4c-0.2,0.1-0.7,0.2-1.1,0.2c-2.2,0-3.8-1.7-3.8-4.1c0-2.3,1.8-4.3,4.2-4.3      c2.6,0,5,2.2,5,6.1c0,4.9-2.9,9.4-6.6,12.1L881.4,449.9z"
                    />
                </g>
                <g>
                    <path
                        class="letter"
                        d="M1082,301.9c2.6-1.7,4.9-4.9,5.2-7.4c-0.2,0.1-0.7,0.2-1.1,0.2c-2.2,0-3.8-1.7-3.8-4.1c0-2.3,1.8-4.3,4.2-4.3      c2.6,0,5,2.2,5,6.1c0,4.9-2.9,9.4-6.6,12.1L1082,301.9z M1094.8,301.9c2.6-1.7,4.8-4.9,5.1-7.4c-0.2,0.1-0.7,0.2-1,0.2      c-2.2,0-3.9-1.7-3.9-4.1c0-2.3,1.9-4.3,4.2-4.3c2.6,0,5,2.2,5,6.1c0,4.9-2.9,9.4-6.5,12.1L1094.8,301.9z"
                    />
                </g>
                <g>
                    <path
                        class="letter"
                        d="M993.7,290.3c15.1,0,25.2,11.4,25.2,25.4c0,12.6-7.1,18.9-13.8,18.9c-4.5,0-7-3.1-7.3-6.5l-0.1-0.5      c-2.8,3.9-7.5,7-12.6,7c-7.4,0-12.2-5.3-12.2-13c0-11.1,9.4-20.1,18.8-20.1c5.2,0,8.7,2.8,10.2,6.2l1-5h5.4l-4.6,21.7      c-0.1,0.5-0.2,1.2-0.2,1.7c0,2.7,1.7,4.2,3.8,4.2c3.1,0,8.6-3.5,8.6-14.6c0-13.1-9-22.6-22.6-22.6c-15.4,0-28.7,13.7-28.7,28.6      c0,12.9,9.7,22.6,23,22.6c5.7,0,10.6-1.8,14.9-4.5l1.4,2.1c-5,3.2-10.7,5-16.6,5c-14.6,0-25.4-11-25.4-25.1      C962,304.6,977.1,290.3,993.7,290.3z M1000.9,311.8c-0.9-2.5-3.5-5.9-8.2-5.9c-8,0-14.2,7.6-14.2,15.3c0,5.1,3,8.9,8.2,8.9      c5.5,0,9.6-3.8,11.9-7.2L1000.9,311.8z"
                    />
                </g>
            </g>
        </g>
    </g>
</svg>
} @if (!numeric) {
<svg
    version="1.1"
    class="svg"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="85 105 1059 568"
    style="enable-background: new 85 105 1059 568"
    xml:space="preserve"
>
    <g class="keyboard">
        <g id="background">
            <g>
                <path
                    class="keyboard-background"
                    d="M1148,656.5c0,8-6.5,14.5-14.5,14.5h-1030c-8,0-14.5-6.5-14.5-14.5v-539c0-8,6.5-14.5,14.5-14.5h1030c8,0,14.5,6.5,14.5,14.5V656.5z"
                />
            </g>
        </g>
        <g id="buttons">
            <g id="first-row">
                <g [id]="keysEnum.q" class="key" (click)="recordKey($event)">
                    <path
                        class="key-shadow"
                        d="M174.6,229.3h-65.2c-6.6,0-12-5.4-12-12v-92.4c0-6.6,5.4-12,12-12h65.2c6.6,0,12,5.4,12,12v92.4C186.6,223.9,181.2,229.3,174.6,229.3z"
                    />
                    <path
                        class="key-background"
                        d="M174.7,226.6h-65.5c-6.6,0-11.9-5.3-11.9-11.9v-90c0-6.6,5.3-11.9,11.9-11.9h65.5c6.6,0,11.9,5.3,11.9,11.9v90C186.6,221.3,181.2,226.6,174.7,226.6z"
                    />
                    @if (!shift) {
                    <path
                        class="letter"
                        d="M152.5,207.1v-20.6c-3.1,4.3-7.8,6.8-13,6.8c-10.2,0-17.2-7.8-17.2-20.3c0-12.6,7-20.2,17.2-20.2c5.4,0,10.2,2.8,13,6.7v-5.8h6v53.4H152.5z M152.5,164.3c-2.1-3.4-6.7-6.2-11.5-6.2c-7.8,0-12.4,6.3-12.4,14.9s4.6,15,12.4,15c4.8,0,9.4-2.9,11.5-6.2V164.3z"
                    />
                    }
                </g>
                <g [id]="keysEnum.w" class="key" (click)="recordKey($event)">
                    <path
                        class="key-shadow"
                        d="M280.4,229.3h-65.2c-6.6,0-12-5.4-12-12v-92.4c0-6.6,5.4-12,12-12h65.2c6.6,0,12,5.4,12,12v92.4C292.4,223.9,287,229.3,280.4,229.3z"
                    />
                    <path
                        class="key-background"
                        d="M280.5,226.6H215c-6.6,0-11.9-5.3-11.9-11.9v-90c0-6.6,5.3-11.9,11.9-11.9h65.5c6.6,0,11.9,5.3,11.9,11.9v90C292.4,221.3,287.1,226.6,280.5,226.6z"
                    />
                    @if (!shift) {
                    <path
                        class="letter"
                        d="M248.5,161.3l-10.1,31h-6l-12.3-38.6h6.2l9.4,30.8l10.2-30.8h5.1l10.2,30.8l9.4-30.8h6.2l-12.3,38.6h-6L248.5,161.3z"
                    />
                    }
                </g>
                <g [id]="keysEnum.e" class="key" (click)="recordKey($event)">
                    <path
                        class="key-shadow"
                        d="M386.3,229.3H321c-6.6,0-12-5.4-12-12v-92.4c0-6.6,5.4-12,12-12h65.2c6.6,0,12,5.4,12,12v92.4C398.3,223.9,392.9,229.3,386.3,229.3z"
                    />
                    <path
                        class="key-background"
                        d="M386.4,226.6h-65.5c-6.6,0-11.9-5.3-11.9-11.9v-90c0-6.6,5.3-11.9,11.9-11.9h65.5c6.6,0,11.9,5.3,11.9,11.9v90C398.3,221.3,393,226.6,386.4,226.6z"
                    />
                    @if (!shift) {
                    <path
                        class="letter"
                        d="M353.8,152.8c11.7,0,18.6,9.1,18.6,20.7v1.5h-31.3c0.5,7.3,5.6,13.4,13.9,13.4c4.4,0,8.9-1.8,11.9-4.9l2.9,3.9c-3.8,3.8-9,5.9-15.4,5.9c-11.4,0-19.7-8.2-19.7-20.3C334.7,161.8,342.7,152.8,353.8,152.8z M341.1,170.6h25.4c-0.1-5.8-3.9-12.9-12.7-12.9C345.5,157.7,341.4,164.7,341.1,170.6z"
                    />
                    }
                </g>
                <g [id]="keysEnum.r" class="key" (click)="recordKey($event)">
                    <path
                        class="key-shadow"
                        d="M492.1,229.3h-65.2c-6.6,0-12-5.4-12-12v-92.4c0-6.6,5.4-12,12-12h65.2c6.6,0,12,5.4,12,12v92.4C504.1,223.9,498.8,229.3,492.1,229.3z"
                    />
                    <path
                        class="key-background"
                        d="M492.3,226.6h-65.5c-6.6,0-11.9-5.3-11.9-11.9v-90c0-6.6,5.3-11.9,11.9-11.9h65.5c6.6,0,11.9,5.3,11.9,11.9v90C504.1,221.3,498.8,226.6,492.3,226.6z"
                    />
                    @if (!shift) {
                    <path
                        class="letter"
                        d="M452.3,153.7h6v6.2c3.1-4.1,7.6-7,12.9-7v6.2c-0.7-0.2-1.4-0.2-2.4-0.2c-3.7,0-8.7,3-10.5,6.2v27.4h-6V153.7z"
                    />
                    }
                </g>
                <g [id]="keysEnum.t" class="key" (click)="recordKey($event)">
                    <path
                        class="key-shadow"
                        d="M598,229.3h-65.2c-6.6,0-12-5.4-12-12v-92.4c0-6.6,5.4-12,12-12H598c6.6,0,12,5.4,12,12v92.4C610,223.9,604.6,229.3,598,229.3z"
                    />
                    <path
                        class="key-background"
                        d="M598.1,226.6h-65.5c-6.6,0-11.9-5.3-11.9-11.9v-90c0-6.6,5.3-11.9,11.9-11.9h65.5c6.6,0,11.9,5.3,11.9,11.9v90C610,221.3,604.7,226.6,598.1,226.6z"
                    />
                    @if (!shift) {
                    <path
                        class="letter"
                        d="M560.9,184.3V159h-6.4v-5.3h6.4v-10.6h6v10.6h7.8v5.3h-7.8v24c0,2.9,1.3,5,3.9,5c1.7,0,3.3-0.7,4.1-1.6l1.8,4.5c-1.5,1.4-3.7,2.5-7.2,2.5C563.8,193.3,560.9,190,560.9,184.3z"
                    />
                    }
                </g>
                <g [id]="keysEnum.y" class="key" (click)="recordKey($event)">
                    <path
                        class="key-shadow"
                        d="M703.8,229.3h-65.2c-6.6,0-12-5.4-12-12v-92.4c0-6.6,5.4-12,12-12h65.2c6.6,0,12,5.4,12,12v92.4C715.8,223.9,710.5,229.3,703.8,229.3z"
                    />
                    <path
                        class="key-background"
                        d="M704,226.6h-65.5c-6.6,0-11.9-5.3-11.9-11.9v-90c0-6.6,5.3-11.9,11.9-11.9H704c6.6,0,11.9,5.3,11.9,11.9v90C715.8,221.3,710.5,226.6,704,226.6z"
                    />
                    @if (!shift) {
                    <path
                        class="letter"
                        d="M660,202.7c2.6,0,4.4-0.9,5.8-4.1l2.6-5.8l-16.2-39h6.5l12.9,31.7l12.8-31.7h6.6l-19.4,46.5c-2.3,5.6-6.2,7.8-11.4,7.8c-1.3,0-3.3-0.2-4.4-0.6l1-5.4C657.6,202.4,659,202.7,660,202.7z"
                    />
                    }
                </g>
                <g [id]="keysEnum.u" class="key" (click)="recordKey($event)">
                    <path
                        class="key-shadow"
                        d="M809.7,229.3h-65.2c-6.6,0-12-5.4-12-12v-92.4c0-6.6,5.4-12,12-12h65.2c6.6,0,12,5.4,12,12v92.4C821.7,223.9,816.3,229.3,809.7,229.3z"
                    />
                    <path
                        class="key-background"
                        d="M809.8,226.6h-65.5c-6.6,0-11.9-5.3-11.9-11.9v-90c0-6.6,5.3-11.9,11.9-11.9h65.5c6.6,0,11.9,5.3,11.9,11.9v90C821.7,221.3,816.4,226.6,809.8,226.6z"
                    />
                    @if (!shift) {
                    <path
                        class="letter"
                        d="M787.5,186.9c-3,3.4-8,6.4-13.8,6.4c-8.1,0-12.3-3.9-12.3-12.3v-27.3h6v25.4c0,6.8,3.4,8.8,8.6,8.8c4.7,0,9.2-2.7,11.4-5.8v-28.4h6v38.6h-6V186.9z"
                    />
                    }
                </g>
                <g [id]="keysEnum.i" class="key" (click)="recordKey($event)">
                    <path
                        class="key-shadow"
                        d="M915.5,229.3h-65.2c-6.6,0-12-5.4-12-12v-92.4c0-6.6,5.4-12,12-12h65.2c6.6,0,12,5.4,12,12v92.4C927.6,223.9,922.2,229.3,915.5,229.3z"
                    />
                    <path
                        class="key-background"
                        d="M915.7,226.6h-65.5c-6.6,0-11.9-5.3-11.9-11.9v-90c0-6.6,5.3-11.9,11.9-11.9h65.5c6.6,0,11.9,5.3,11.9,11.9v90C927.6,221.3,922.2,226.6,915.7,226.6z"
                    />
                    @if (!shift) {
                    <path
                        class="letter"
                        d="M879.5,143.2c0-2.2,1.8-4,4-4c2.2,0,4.1,1.8,4.1,4s-1.8,4.1-4.1,4.1C881.3,147.2,879.5,145.4,879.5,143.2z M880.5,153.7h6v38.6h-6V153.7z"
                    />
                    }
                </g>
                <g [id]="keysEnum.o" class="key" (click)="recordKey($event)">
                    <path
                        class="key-shadow"
                        d="M1021.4,229.3h-65.2c-6.6,0-12-5.4-12-12v-92.4c0-6.6,5.4-12,12-12h65.2c6.6,0,12,5.4,12,12v92.4C1033.4,223.9,1028,229.3,1021.4,229.3z"
                    />
                    <path
                        class="key-background"
                        d="M1021.5,226.6H956c-6.6,0-11.9-5.3-11.9-11.9v-90c0-6.6,5.3-11.9,11.9-11.9h65.5c6.6,0,11.9,5.3,11.9,11.9v90C1033.4,221.3,1028.1,226.6,1021.5,226.6z"
                    />
                    @if (!shift) {
                    <path
                        class="letter"
                        d="M969.4,173c0-11.2,7.4-20.2,19.1-20.2c11.8,0,19.1,9,19.1,20.2s-7.4,20.3-19.1,20.3C976.7,193.3,969.4,184.2,969.4,173zM1001.3,173c0-7.8-4.6-14.9-12.8-14.9s-12.9,7-12.9,14.9c0,7.9,4.6,15,12.9,15S1001.3,180.9,1001.3,173z"
                    />
                    }
                </g>
                <g [id]="keysEnum.p" class="key" (click)="recordKey($event)">
                    <path
                        class="key-shadow"
                        d="M1127.3,229.3H1062c-6.6,0-12-5.4-12-12v-92.4c0-6.6,5.4-12,12-12h65.2c6.6,0,12,5.4,12,12v92.4C1139.3,223.9,1133.9,229.3,1127.3,229.3z"
                    />
                    <path
                        class="key-background"
                        d="M1127.4,226.6h-65.5c-6.6,0-11.9-5.3-11.9-11.9v-90c0-6.6,5.3-11.9,11.9-11.9h65.5c6.6,0,11.9,5.3,11.9,11.9v90C1139.3,221.3,1134,226.6,1127.4,226.6z"
                    />
                    @if (!shift) {
                    <path
                        class="letter"
                        d="M1077.5,207.1v-53.4h6v5.8c2.8-3.9,7.6-6.7,13-6.7c10.2,0,17.2,7.7,17.2,20.2c0,12.5-7,20.3-17.2,20.3c-5.3,0-9.9-2.5-13-6.8v20.6H1077.5z M1095.1,158.1c-4.7,0-9.4,2.8-11.5,6.2v17.4c2.1,3.4,6.8,6.2,11.5,6.2c7.8,0,12.4-6.4,12.4-15S1102.8,158.1,1095.1,158.1z"
                    />
                    }
                </g>
            </g>
            <g id="second-row">
                <g [id]="keysEnum.a" class="key" (click)="recordKey($event)">
                    <path
                        class="key-shadow"
                        d="M226.6,375.3h-65.2c-6.6,0-12-5.4-12-12V271c0-6.6,5.4-12,12-12h65.2c6.6,0,12,5.4,12,12v92.4C238.6,370,233.2,375.3,226.6,375.3z"
                    />
                    <path
                        class="key-background"
                        d="M226.7,372.6h-65.5c-6.6,0-11.9-5.3-11.9-11.9v-90c0-6.6,5.3-11.9,11.9-11.9h65.5c6.6,0,11.9,5.3,11.9,11.9v90C238.6,367.3,233.3,372.6,226.7,372.6z"
                    />
                    @if (!shift) {
                    <path
                        class="letter"
                        d="M202.1,333c-3.2,3.5-7.6,5.4-12.8,5.4c-6.6,0-13.5-4.4-13.5-12.8c0-8.6,7-12.7,13.5-12.7c5.3,0,9.7,1.7,12.8,5.3v-7c0-5.2-4.2-8.2-9.8-8.2c-4.6,0-8.4,1.7-11.8,5.4l-2.8-4.2c4.2-4.3,9.1-6.4,15.4-6.4c8.2,0,15,3.7,15,13v26.6h-6V333zM202.1,321.9c-2.3-3.2-6.4-4.8-10.6-4.8c-5.6,0-9.5,3.5-9.5,8.5c0,4.9,3.9,8.4,9.5,8.4c4.2,0,8.3-1.6,10.6-4.8V321.9z"
                    />
                    }
                </g>
                <g [id]="keysEnum.s" class="key" (click)="recordKey($event)">
                    <path
                        class="key-shadow"
                        d="M332.6,375.3h-65.2c-6.6,0-12-5.4-12-12V271c0-6.6,5.4-12,12-12h65.2c6.6,0,12,5.4,12,12v92.4C344.6,370,339.3,375.3,332.6,375.3z"
                    />
                    <path
                        class="key-background"
                        d="M332.8,372.6h-65.5c-6.6,0-11.9-5.3-11.9-11.9v-90c0-6.6,5.3-11.9,11.9-11.9h65.5c6.6,0,11.9,5.3,11.9,11.9v90C344.6,367.3,339.3,372.6,332.8,372.6z"
                    />
                    @if (!shift) {
                    <path
                        class="letter"
                        d="M287.7,327.9c2.6,3,7.4,5.5,12.7,5.5c5.9,0,9.1-2.6,9.1-6.4c0-4.2-4.7-5.6-9.9-6.9c-6.6-1.5-14-3.3-14-11.3c0-6,5.2-11.1,14.4-11.1c6.6,0,11.2,2.5,14.3,5.6l-2.8,4.2c-2.3-2.8-6.6-4.9-11.5-4.9c-5.3,0-8.6,2.4-8.6,5.8c0,3.8,4.4,5,9.4,6.2c6.7,1.5,14.5,3.4,14.5,12c0,6.5-5.2,11.7-15.2,11.7c-6.3,0-11.7-1.9-15.6-6.1L287.7,327.9z"
                    />
                    }
                </g>
                <g [id]="keysEnum.d" class="key" (click)="recordKey($event)">
                    <path
                        class="key-shadow"
                        d="M438.3,375.3h-65.2c-6.6,0-12-5.4-12-12V271c0-6.6,5.4-12,12-12h65.2c6.6,0,12,5.4,12,12v92.4C450.3,370,444.9,375.3,438.3,375.3z"
                    />
                    <path
                        class="key-background"
                        d="M438.4,372.6h-65.5c-6.6,0-11.9-5.3-11.9-11.9v-90c0-6.6,5.3-11.9,11.9-11.9h65.5c6.6,0,11.9,5.3,11.9,11.9v90C450.3,367.3,445,372.6,438.4,372.6z"
                    />
                    @if (!shift) {
                    <path
                        class="letter"
                        d="M417,331.6c-2.9,3.9-7.6,6.7-13,6.7c-10.1,0-17.2-7.7-17.2-20.2c0-12.3,7-20.3,17.2-20.3c5.2,0,9.9,2.6,13,6.8V284h6v53.4h-6V331.6z M417,309.4c-2.2-3.4-6.8-6.2-11.6-6.2c-7.8,0-12.4,6.4-12.4,15c0,8.6,4.6,14.9,12.4,14.9c4.8,0,9.4-2.7,11.6-6.1V309.4z"
                    />
                    }
                </g>
                <g [id]="keysEnum.f" class="key" (click)="recordKey($event)">
                    <path
                        class="key-shadow"
                        d="M544.3,375.3h-65.2c-6.6,0-12-5.4-12-12V271c0-6.6,5.4-12,12-12h65.2c6.6,0,12,5.4,12,12v92.4C556.4,370,551,375.3,544.3,375.3z"
                    />
                    <path
                        class="key-background"
                        d="M544.5,372.6H479c-6.6,0-11.9-5.3-11.9-11.9v-90c0-6.6,5.3-11.9,11.9-11.9h65.5c6.6,0,11.9,5.3,11.9,11.9v90C556.4,367.3,551,372.6,544.5,372.6z"
                    />
                    @if (!shift) {
                    <path
                        class="letter"
                        d="M507.9,304h-6.4v-5.3h6.4v-3c0-8,4.5-12.6,11.2-12.6c2.2,0,4.3,0.4,5.8,1.4l-1.5,4.5c-1-0.6-2.1-0.9-3.4-0.9c-3.9,0-6.1,2.7-6.1,7.6v3h7.8v5.3h-7.8v33.4h-6V304z"
                    />
                    }
                </g>
                <g [id]="keysEnum.g" class="key" (click)="recordKey($event)">
                    <path
                        class="key-shadow"
                        d="M652,375.3h-65.2c-6.6,0-12-5.4-12-12V271c0-6.6,5.4-12,12-12H652c6.6,0,12,5.4,12,12v92.4C664,370,658.6,375.3,652,375.3z"
                    />
                    <path
                        class="key-background"
                        d="M652.1,372.6h-65.5c-6.6,0-11.9-5.3-11.9-11.9v-90c0-6.6,5.3-11.9,11.9-11.9h65.5c6.6,0,11.9,5.3,11.9,11.9v90C664,367.3,658.7,372.6,652.1,372.6z"
                    />
                    @if (!shift) {
                    <path
                        class="letter"
                        d="M605.5,342.8c3.2,3.8,7,5.3,12.6,5.3c6.4,0,12.4-3.1,12.4-11.6V331c-2.8,3.9-7.5,6.9-13,6.9c-10.1,0-17.2-7.5-17.2-20c0-12.4,7-20.1,17.2-20.1c5.2,0,9.8,2.6,13,6.8v-5.8h6v37.5c0,12.8-9,16.8-18.4,16.8c-6.6,0-11-1.3-15.6-5.8L605.5,342.8zM630.5,309.4c-2.1-3.4-6.7-6.2-11.5-6.2c-7.8,0-12.4,6.2-12.4,14.7c0,8.5,4.6,14.7,12.4,14.7c4.8,0,9.4-3,11.5-6.3V309.4z"
                    />
                    }
                </g>
                <g [id]="keysEnum.h" class="key" (click)="recordKey($event)">
                    <path
                        class="key-shadow"
                        d="M757.3,375.3H692c-6.6,0-12-5.4-12-12V271c0-6.6,5.4-12,12-12h65.2c6.6,0,12,5.4,12,12v92.4C769.3,370,763.9,375.3,757.3,375.3z"
                    />
                    <path
                        class="key-background"
                        d="M757.4,372.6h-65.5c-6.6,0-11.9-5.3-11.9-11.9v-90c0-6.6,5.3-11.9,11.9-11.9h65.5c6.6,0,11.9,5.3,11.9,11.9v90C769.3,367.3,764,372.6,757.4,372.6z"
                    />
                    @if (!shift) {
                    <path
                        class="letter"
                        d="M735.1,311.9c0-6.8-3.5-8.8-8.7-8.8c-4.6,0-9.1,2.9-11.4,6v28.2h-6V284h6v20.3c2.7-3.2,8-6.6,13.8-6.6c8.1,0,12.3,3.9,12.3,12.3v27.3h-6V311.9z"
                    />
                    }
                </g>
                <g [id]="keysEnum.j" class="key" (click)="recordKey($event)">
                    <path
                        class="key-shadow"
                        d="M863.3,375.3h-65.2c-6.6,0-12-5.4-12-12V271c0-6.6,5.4-12,12-12h65.2c6.6,0,12,5.4,12,12v92.4C875.3,370,870,375.3,863.3,375.3z"
                    />
                    <path
                        class="key-background"
                        d="M863.5,372.6h-65.5c-6.6,0-11.9-5.3-11.9-11.9v-90c0-6.6,5.3-11.9,11.9-11.9h65.5c6.6,0,11.9,5.3,11.9,11.9v90C875.3,367.3,870,372.6,863.5,372.6z"
                    />
                    @if (!shift) {
                    <path
                        class="letter"
                        d="M833,341.1c0,7.6-4.1,11.9-11.4,11.9c-1.7,0-3-0.2-4.3-0.6l0.8-5c0.8,0.3,1.9,0.4,2.9,0.4c3.5,0,6-1.8,6-6.7v-42.4h6V341.1z M826,288.2c0-2.2,1.8-4,4-4c2.2,0,4.1,1.8,4.1,4s-1.8,4.1-4.1,4.1C827.8,292.2,826,290.4,826,288.2z"
                    />
                    }
                </g>
                <g [id]="keysEnum.k" class="key" (click)="recordKey($event)">
                    <path
                        class="key-shadow"
                        d="M969.2,375.3h-65.2c-6.6,0-12-5.4-12-12V271c0-6.6,5.4-12,12-12h65.2c6.6,0,12,5.4,12,12v92.4C981.2,370,975.8,375.3,969.2,375.3z"
                    />
                    <path
                        class="key-background"
                        d="M969.3,372.6h-65.5c-6.6,0-11.9-5.3-11.9-11.9v-90c0-6.6,5.3-11.9,11.9-11.9h65.5c6.6,0,11.9,5.3,11.9,11.9v90C981.2,367.3,975.9,372.6,969.3,372.6z"
                    />
                    @if (!shift) {
                    <path
                        class="letter"
                        d="M933.8,320l-6.4,6.3v11h-6V284h6v35.3l20.3-20.6h7.6l-17.1,17.5l17.2,21.1h-7.7L933.8,320z"
                    />
                    }
                </g>
                <g [id]="keysEnum.l" class="key" (click)="recordKey($event)">
                    <path
                        class="key-shadow"
                        d="M1075,375.3h-65.2c-6.6,0-12-5.4-12-12V271c0-6.6,5.4-12,12-12h65.2c6.6,0,12,5.4,12,12v92.4C1087,370,1081.7,375.3,1075,375.3z"
                    />
                    <path
                        class="key-background"
                        d="M1075.2,372.6h-65.5c-6.6,0-11.9-5.3-11.9-11.9v-90c0-6.6,5.3-11.9,11.9-11.9h65.5c6.6,0,11.9,5.3,11.9,11.9v90C1087,367.3,1081.7,372.6,1075.2,372.6z"
                    />
                    @if (!shift) {
                    <path class="letter" d="M1039.5,284h6v53.4h-6V284z" />
                    }
                </g>
            </g>
            <g id="third-row">
                <g [id]="keysEnum.Shift" class="key" (click)="toggleShift()">
                    <path
                        class="key-shadow"
                        d="M202.1,521.9h-90.9c-7.7,0-13.9-6.2-13.9-13.9v-88.4c0-7.7,6.2-13.9,13.9-13.9h90.9c7.7,0,13.9,6.2,13.9,13.9V508C216,515.7,209.8,521.9,202.1,521.9z"
                    />
                    <path
                        class="action-key"
                        [class.active]="shift"
                        d="M202.2,519.5h-91.2c-7.6,0-13.8-6.2-13.8-13.8v-86.3c0-7.6,6.2-13.8,13.8-13.8h91.2c7.6,0,13.8,6.2,13.8,13.8v86.3C216,513.3,209.9,519.5,202.2,519.5z"
                    />
                    <path
                        class="symbol-key"
                        [class.active]="shift"
                        d="M175.4,490.8c0,3.4-2.8,6.2-6.2,6.2H142c-3.4,0-6.2-2.8-6.2-6.2v-17.9h-9.3c-2.2,0-4.2-1.3-5.1-3.4c-0.9-2.1-0.4-4.4,1.2-6l33-33l33,33c1.6,1.6,2,3.9,1.2,6c-0.9,2.1-2.9,3.4-5.1,3.4h-9.3V490.8z M127.7,466.9h14v23.9c0,0.1,0.1,0.2,0.2,0.2h27.3c0.1,0,0.2-0.1,0.2-0.2v-23.9h14L155.6,439L127.7,466.9z"
                    />
                </g>
                <g [id]="keysEnum.z" class="key" (click)="recordKey($event)">
                    <path
                        class="key-shadow"
                        d="M332.6,521.9h-65.2c-6.6,0-12-5.4-12-12v-92.4c0-6.6,5.4-12,12-12h65.2c6.6,0,12,5.4,12,12v92.4C344.6,516.6,339.3,521.9,332.6,521.9z"
                    />
                    <path
                        class="key-background"
                        d="M332.8,519.2h-65.5c-6.6,0-11.9-5.3-11.9-11.9v-90c0-6.6,5.3-11.9,11.9-11.9h65.5c6.6,0,11.9,5.3,11.9,11.9v90C344.6,513.9,339.3,519.2,332.8,519.2z"
                    />
                    @if (!shift) {
                    <path
                        class="letter"
                        d="M285.8,479.7l21.3-28.7h-21.3v-5.3h29.1v4.6l-21.4,28.9h21.8v5.2h-29.4V479.7z"
                    />
                    }
                </g>
                <g [id]="keysEnum.x" class="key" (click)="recordKey($event)">
                    <path
                        class="key-shadow"
                        d="M438.7,521.9h-65.2c-6.6,0-12-5.4-12-12v-92.4c0-6.6,5.4-12,12-12h65.2c6.6,0,12,5.4,12,12v92.4C450.7,516.6,445.3,521.9,438.7,521.9z"
                    />
                    <path
                        class="key-background"
                        d="M438.8,519.2h-65.5c-6.6,0-11.9-5.3-11.9-11.9v-90c0-6.6,5.3-11.9,11.9-11.9h65.5c6.6,0,11.9,5.3,11.9,11.9v90C450.7,513.9,445.4,519.2,438.8,519.2z"
                    />
                    @if (!shift) {
                    <path
                        class="letter"
                        d="M406,468.5l-11.6,15.8h-6.9l14.8-19.8l-14-18.8h7l10.7,14.7l10.7-14.7h7l-14,18.8l14.9,19.8h-7L406,468.5z"
                    />
                    }
                </g>
                <g [id]="keysEnum.c" class="key" (click)="recordKey($event)">
                    <path
                        class="key-shadow"
                        d="M544.2,521.9h-65.2c-6.6,0-12-5.4-12-12v-92.4c0-6.6,5.4-12,12-12h65.2c6.6,0,12,5.4,12,12v92.4C556.2,516.6,550.8,521.9,544.2,521.9z"
                    />
                    <path
                        class="key-background"
                        d="M544.3,519.2h-65.5c-6.6,0-11.9-5.3-11.9-11.9v-90c0-6.6,5.3-11.9,11.9-11.9h65.5c6.6,0,11.9,5.3,11.9,11.9v90C556.2,513.9,550.9,519.2,544.3,519.2z"
                    />
                    @if (!shift) {
                    <path
                        class="letter"
                        d="M514.7,444.8c7,0,11.2,2.9,14.2,6.7l-4,3.7c-2.6-3.5-5.8-5-9.8-5c-8.2,0-13.4,6.3-13.4,14.9s5.1,15,13.4,15c4,0,7.3-1.6,9.8-5l4,3.7c-3,3.8-7.1,6.7-14.2,6.7c-11.5,0-19.3-8.8-19.3-20.3C495.5,453.6,503.2,444.8,514.7,444.8z"
                    />
                    }
                </g>
                <g [id]="keysEnum.v" class="key" (click)="recordKey($event)">
                    <path
                        class="key-shadow"
                        d="M652,521.9h-65.2c-6.6,0-12-5.4-12-12v-92.4c0-6.6,5.4-12,12-12H652c6.6,0,12,5.4,12,12v92.4C664,516.6,658.6,521.9,652,521.9z"
                    />
                    <path
                        class="key-background"
                        d="M652.1,519.2h-65.5c-6.6,0-11.9-5.3-11.9-11.9v-90c0-6.6,5.3-11.9,11.9-11.9h65.5c6.6,0,11.9,5.3,11.9,11.9v90C664,513.9,658.7,519.2,652.1,519.2z"
                    />
                    @if (!shift) {
                    <path
                        class="letter"
                        d="M600.1,445.7h6.5l12.9,31.7l12.8-31.7h6.6l-16.1,38.6h-6.6L600.1,445.7z"
                    />
                    }
                </g>
                <g [id]="keysEnum.b" class="key" (click)="recordKey($event)">
                    <path
                        class="key-shadow"
                        d="M757.3,521.9H692c-6.6,0-12-5.4-12-12v-92.4c0-6.6,5.4-12,12-12h65.2c6.6,0,12,5.4,12,12v92.4C769.3,516.6,763.9,521.9,757.3,521.9z"
                    />
                    <path
                        class="key-background"
                        d="M757.4,519.2h-65.5c-6.6,0-11.9-5.3-11.9-11.9v-90c0-6.6,5.3-11.9,11.9-11.9h65.5c6.6,0,11.9,5.3,11.9,11.9v90C769.3,513.9,764,519.2,757.4,519.2z"
                    />
                    @if (!shift) {
                    <path
                        class="letter"
                        d="M708,431h6v20.6c3.1-4.2,7.8-6.8,13-6.8c10.1,0,17.2,8,17.2,20.3c0,12.6-7.1,20.2-17.2,20.2c-5.4,0-10.2-2.8-13-6.7v5.8h-6V431z M725.5,480c7.8,0,12.5-6.3,12.5-14.9c0-8.6-4.6-15-12.5-15c-4.7,0-9.4,2.9-11.5,6.2v17.5C716.1,477.2,720.8,480,725.5,480z"
                    />
                    }
                </g>
                <g [id]="keysEnum.n" class="key" (click)="recordKey($event)">
                    <path
                        class="key-shadow"
                        d="M863.3,521.9h-65.2c-6.6,0-12-5.4-12-12v-92.4c0-6.6,5.4-12,12-12h65.2c6.6,0,12,5.4,12,12v92.4C875.3,516.6,870,521.9,863.3,521.9z"
                    />
                    <path
                        class="key-background"
                        d="M863.5,519.2h-65.5c-6.6,0-11.9-5.3-11.9-11.9v-90c0-6.6,5.3-11.9,11.9-11.9h65.5c6.6,0,11.9,5.3,11.9,11.9v90C875.3,513.9,870,519.2,863.5,519.2z"
                    />
                    @if (!shift) {
                    <path
                        class="letter"
                        d="M840,459.1c0-6.8-3.4-9-8.6-9c-4.7,0-9.2,2.9-11.4,6v28.2h-6v-38.6h6v5.6c2.7-3.2,8-6.6,13.8-6.6c8.1,0,12.3,4.1,12.3,12.5v27.1h-6V459.1z"
                    />
                    }
                </g>
                <g [id]="keysEnum.m" class="key" (click)="recordKey($event)">
                    <path
                        class="key-shadow"
                        d="M969.4,521.9h-65.2c-6.6,0-12-5.4-12-12v-92.4c0-6.6,5.4-12,12-12h65.2c6.6,0,12,5.4,12,12v92.4C981.4,516.6,976,521.9,969.4,521.9z"
                    />
                    <path
                        class="key-background"
                        d="M969.5,519.2H904c-6.6,0-11.9-5.3-11.9-11.9v-90c0-6.6,5.3-11.9,11.9-11.9h65.5c6.6,0,11.9,5.3,11.9,11.9v90C981.4,513.9,976.1,519.2,969.5,519.2z"
                    />
                    @if (!shift) {
                    <path
                        class="letter"
                        d="M956.3,458.1c0-4.9-2.2-8-7.1-8c-4,0-8.2,2.9-10.2,5.9v28.3h-6v-26.2c0-4.9-2.1-8-7.1-8c-3.9,0-8.1,2.9-10.2,6v28.2h-6v-38.6h6v5.6c1.6-2.5,6.8-6.6,12.5-6.6c5.9,0,9.3,3.2,10.4,7.2c2.2-3.5,7.4-7.2,13-7.2c7,0,10.8,3.9,10.8,11.7v27.9h-6V458.1z"
                    />
                    }
                </g>
                <g
                    [id]="keysEnum.Backspace"
                    class="key"
                    (click)="recordKey($event)"
                >
                    <path
                        class="key-shadow"
                        d="M1125.2,521.9h-90.9c-7.7,0-13.9-6.2-13.9-13.9v-88.4c0-7.7,6.2-13.9,13.9-13.9h90.9c7.7,0,13.9,6.2,13.9,13.9V508C1139.1,515.7,1132.9,521.9,1125.2,521.9z"
                    />
                    <path
                        class="action-key"
                        d="M1125.3,519.5h-91.2c-7.6,0-13.8-6.2-13.8-13.8v-86.3c0-7.6,6.2-13.8,13.8-13.8h91.2c7.6,0,13.8,6.2,13.8,13.8v86.3C1139.1,513.3,1132.9,519.5,1125.3,519.5z"
                    />
                    <path
                        class="symbol-key"
                        d="M1112,441c0-1.1-0.9-2-2-2h-44.3c-0.7,0-1.3,0.3-1.7,0.9l-14.4,22.1l14.4,22.1c0.4,0.6,1,0.9,1.7,0.9h44.3c1.1,0,2-0.9,2-2V441z M1110,433c4.4,0,8,3.6,8,8v42c0,4.4-3.6,8-8,8h-44.3c-2.7,0-5.2-1.4-6.7-3.6l-16.6-25.4l16.6-25.4c1.5-2.3,4-3.6,6.7-3.6H1110z M1097.4,453.7l-8.3,8.3l8.3,8.3c1.2,1.2,1.2,3.1,0,4.2c-0.6,0.6-1.4,0.9-2.1,0.9c-0.8,0-1.5-0.3-2.1-0.9l-8.3-8.3l-8.3,8.3c-0.6,0.6-1.4,0.9-2.1,0.9c-0.8,0-1.5-0.3-2.1-0.9c-1.2-1.2-1.2-3.1,0-4.2l8.3-8.3l-8.3-8.3c-1.2-1.2-1.2-3.1,0-4.2c1.2-1.2,3.1-1.2,4.2,0l8.3,8.3l8.3-8.3c1.2-1.2,3.1-1.2,4.2,0C1098.6,450.7,1098.6,452.6,1097.4,453.7z"
                    />
                </g>
            </g>
            <g id="forth-row">
                <g
                    [id]="keysEnum.Space"
                    class="key"
                    (click)="recordKey($event)"
                >
                    <path
                        class="key-shadow"
                        d="M860.2,546.1H524H482H373.4c-6.6,0-12,5.4-12,12v92.4c0,6.6,5.4,12,12,12H482H524h336.2c8.4,0,15.1-6.8,15.1-15.1v-86.1C875.3,552.8,868.6,546.1,860.2,546.1z"
                    />
                    <path
                        class="key-background"
                        d="M860.5,546.1H573.1h-91.4H373.3c-6.6,0-11.9,5.3-11.9,11.9v90c0,6.6,5.3,11.9,11.9,11.9h108.5h91.4h287.4c8.2,0,14.8-6.6,14.8-14.8v-84C875.3,552.7,868.7,546.1,860.5,546.1z"
                    />
                </g>
                <g
                    [id]="keysEnum.Enter"
                    class="key"
                    (click)="recordKey($event)"
                >
                    <path
                        class="key-shadow"
                        d="M1127.3,662.5H903.9c-6.5,0-11.8-5.3-11.8-11.8v-92.9c0-6.5,5.3-11.8,11.8-11.8h223.5c6.5,0,11.8,5.3,11.8,11.8v92.9C1139.1,657.2,1133.8,662.5,1127.3,662.5z"
                    />
                    <path
                        class="action-key"
                        d="M1127.6,659.8H903.6c-6.4,0-11.5-5.2-11.5-11.5v-90.6c0-6.4,5.2-11.5,11.5-11.5h223.9c6.4,0,11.5,5.2,11.5,11.5v90.6C1139.1,654.6,1133.9,659.8,1127.6,659.8z"
                    />
                    <path
                        class="symbol-key"
                        d="M1003.2,607l9.9,9.9l-4.2,4.2L991.8,604l17.1-17.1l4.2,4.2l-9.9,9.9h38.8v-12h6v18H1003.2z"
                    />
                </g>
                <g id="toggleNumbers" class="key" (click)="toggleNumeric()">
                    <path
                        class="action-key"
                        d="M331.1,546.1H199.6c-0.2,0-0.3,0-0.5,0c-0.2,0-0.3,0-0.5,0h-87.7c-7.5,0-13.6,6.1-13.6,13.6v86.7     c0,7.5,6.1,13.6,13.6,13.6h87.7c0.2,0,0.3,0,0.5,0c0.2,0,0.3,0,0.5,0h131.5c7.5,0,13.6-6.1,13.6-13.6v-86.7     C344.6,552.2,338.6,546.1,331.1,546.1z"
                    />
                    <path
                        class="symbol-key"
                        d="M183.9,599.5l-5.4,5.7l-3-3l9-9.2h4.4v33.4h-5V599.5z"
                    />
                    <path
                        class="symbol-key"
                        d="M195.2,622.4c12.5-9.6,18.3-14.6,18.3-19.9c0-3.9-3.2-5.6-6.5-5.6c-4,0-7,1.7-9.1,4.1l-3-3.2c2.8-3.5,7.3-5.3,12-5.3c6,0,11.7,3.4,11.7,10.1c0,6.5-6.3,12.3-15.4,19.4h15.6v4.4h-23.5V622.4z"
                    />
                    <path
                        class="symbol-key"
                        d="M226.2,618.2c2.1,2.5,5.6,4.3,9.3,4.3c4.6,0,7.4-2.2,7.4-5.7c0-3.7-3-5.2-7.9-5.2c-1.4,0-3.1,0-3.6,0V607c0.5,0,2.3,0,3.6,0c4.1,0,7.4-1.5,7.4-5c0-3.4-3.2-5.2-7.2-5.2c-3.5,0-6.2,1.4-8.7,3.9l-2.7-3.1c2.5-2.9,6.5-5.2,11.8-5.2c6.8,0,11.7,3.3,11.7,9c0,4.6-4,7.1-7.3,7.7c3.2,0.3,7.8,2.9,7.8,8.2c0,5.6-4.7,9.7-12.2,9.7c-5.8,0-10.1-2.4-12.3-5.4"
                    />
                </g>
            </g>
            @if (shift) {
            <g id="uppercase-keys">
                <g>
                    <path
                        class="letter"
                        d="M160.7,189.4l5,5.4l-4.6,4l-5.1-5.5c-4.1,2.6-9,4-14.5,4c-15.8,0-26.5-11.8-26.5-27.6s10.6-27.6,26.5-27.6
                        c15.8,0,26.5,11.8,26.5,27.6C167.9,177.6,165.3,184.4,160.7,189.4z M151.6,188.7l-7.6-8.2l4.6-3.9l7.5,8.1
                        c3.1-3.8,4.9-9,4.9-14.9c0-12.5-7.7-21.7-19.6-21.7c-12,0-19.6,9.2-19.6,21.7c0,12.4,7.6,21.7,19.6,21.7
                        C145.4,191.4,148.7,190.4,151.6,188.7z"
                    />
                </g>
                <g>
                    <path
                        class="letter"
                        d="M248.5,153.3l-11.8,43h-7.2L214.3,143h7.4l11.8,44.5l12.2-44.5h5.5l12.2,44.5l11.8-44.5h7.4l-15.2,53.4h-7.2
                        L248.5,153.3z"
                    />
                </g>
                <g>
                    <path
                        class="letter"
                        d="M337,143h35v5.9h-28.3v17.2h27.8v5.9h-27.8v18.4h28.3v5.9h-35V143z"
                    />
                </g>
                <g>
                    <path
                        class="letter"
                        d="M458.7,175.2h-10.6v21.2h-6.6V143h21.4c9.8,0,16.7,6.2,16.7,16.1c0,9.6-6.6,14.9-13.8,15.5l14.4,21.8h-7.8L458.7,175.2z
                         M462.1,148.9h-14v20.4h14c6.3,0,10.6-4.2,10.6-10.2S468.4,148.9,462.1,148.9z"
                    />
                </g>
                <g>
                    <path
                        class="letter"
                        d="M562.1,148.9h-16.9V143h40.5v5.9h-17v47.4h-6.6V148.9z"
                    />
                </g>
                <g>
                    <path
                        class="letter"
                        d="M668.2,173.8l-21-30.8h7.8l16.6,24.8l16.6-24.8h7.8l-21,30.8v22.6h-6.6V173.8z"
                    />
                </g>
                <g>
                    <path
                        class="letter"
                        d="M755.7,143h6.6v32.5c0,9.8,5.3,15.9,15.1,15.9c9.8,0,15.1-6.2,15.1-15.9V143h6.6v32.6c0,13.3-7.3,21.8-21.8,21.8
                        c-14.5,0-21.8-8.6-21.8-21.7V143z"
                    />
                </g>
                <g>
                    <path class="letter" d="M880.2,143h6.6v53.4h-6.6V143z" />
                </g>
                <g>
                    <path
                        class="letter"
                        d="M988.5,142.1c15.8,0,26.5,11.8,26.5,27.6s-10.7,27.6-26.5,27.6c-15.8,0-26.5-11.8-26.5-27.6S972.6,142.1,988.5,142.1z
                         M988.5,148c-12,0-19.6,9.2-19.6,21.7c0,12.4,7.6,21.7,19.6,21.7c11.9,0,19.6-9.3,19.6-21.7C1008.1,157.2,1000.4,148,988.5,148z
                        "
                    />
                </g>
                <g>
                    <path
                        class="letter"
                        d="M1077.3,143h21.4c10.7,0,16.7,7.4,16.7,16.1s-6.2,16.1-16.7,16.1h-14.8v21.2h-6.6V143z M1097.9,148.9h-14v20.3h14
                        c6.3,0,10.6-4.2,10.6-10.2S1104.2,148.9,1097.9,148.9z"
                    />
                </g>
                <g>
                    <path
                        class="letter"
                        d="M206.5,329.5h-27l-4.7,11.8h-7.4l21.4-53.4h8.2l21.5,53.4h-7.4L206.5,329.5z M181.4,323.6h23.1L193,293.9L181.4,323.6z"
                    />
                </g>
                <g>
                    <path
                        class="letter"
                        d="M284,328.8c3.5,3.9,9.3,7.6,16.8,7.6c9.5,0,12.6-5.1,12.6-9.2c0-6.4-6.5-8.2-13.5-10.1c-8.6-2.2-18.1-4.6-18.1-15.1
                        c0-8.8,7.8-14.8,18.3-14.8c8.2,0,14.5,2.7,19,7.4l-4,4.9c-4-4.4-9.6-6.4-15.4-6.4c-6.4,0-11,3.4-11,8.5c0,5.4,6.2,7,13,8.8
                        c8.7,2.3,18.6,5,18.6,16.2c0,7.8-5.3,15.7-19.7,15.7c-9.3,0-16.1-3.5-20.5-8.5L284,328.8z"
                    />
                </g>
                <g>
                    <path
                        class="letter"
                        d="M384.2,288h18.2c16.6,0,27.4,11.6,27.4,26.7c0,15.2-10.8,26.6-27.4,26.6h-18.2V288z M402.5,335.4
                        c13,0,20.5-9.3,20.5-20.7c0-11.5-7.3-20.8-20.5-20.8h-11.6v41.5H402.5z"
                    />
                </g>
                <g>
                    <path
                        class="letter"
                        d="M495.7,288h35v5.9h-28.3v17.2h27.8v5.9h-27.8v24.3h-6.6V288z"
                    />
                </g>
                <g>
                    <path
                        class="letter"
                        d="M622.5,287.1c9.4,0,16,4.2,20.7,10l-5.3,3.3c-3.4-4.3-9-7.4-15.4-7.4c-11.7,0-20.6,9-20.6,21.7
                        c0,12.6,8.9,21.8,20.6,21.8c6.4,0,11.7-3.1,14.3-5.8v-10.9h-18.3v-5.9h25v19.3c-5,5.5-12.2,9.2-21,9.2
                        c-15.2,0-27.4-11.1-27.4-27.7S607.3,287.1,622.5,287.1z"
                    />
                </g>
                <g>
                    <path
                        class="letter"
                        d="M740.6,316.9h-31.2v24.5h-6.6V288h6.6v23h31.2v-23h6.6v53.4h-6.6V316.9z"
                    />
                </g>
                <g>
                    <path
                        class="letter"
                        d="M815.3,331.1c2.3,2.8,5.4,5.3,10.1,5.3c6.6,0,10.7-4.6,10.7-11.2V288h6.6v37.3c0,11.6-7.4,17-17,17
                        c-5.7,0-10.2-1.8-13.9-6.2L815.3,331.1z"
                    />
                </g>
                <g>
                    <path
                        class="letter"
                        d="M930.2,317.4l-5.4,6.1v17.9h-6.6V288h6.6v27.6l23.6-27.6h8.3l-22.2,25.4l24.2,28h-8.2L930.2,317.4z"
                    />
                </g>
                <g>
                    <path
                        class="letter"
                        d="M280.9,482.8l30-41.9h-30V435h38.5v5.5l-30,41.9H320v5.9h-39V482.8z"
                    />
                </g>
                <g>
                    <path
                        class="letter"
                        d="M406,465.6l-17,22.7h-8.1l20.8-27.4l-19.6-26h8.1l15.8,21.4l15.8-21.4h8.1l-19.5,25.9l20.7,27.4h-8L406,465.6z"
                    />
                </g>
                <g>
                    <path
                        class="letter"
                        d="M488.5,461.7c0-16.4,12.1-27.6,27.2-27.6c9.7,0,16.2,4.6,20.5,10.6l-5.6,3.1c-3-4.5-8.6-7.8-14.9-7.8
                        c-11.4,0-20.3,9-20.3,21.7c0,12.6,8.9,21.7,20.3,21.7c6.3,0,11.8-3.2,14.9-7.8l5.7,3.1c-4.5,6.1-10.9,10.6-20.6,10.6
                        C500.6,489.3,488.5,478.1,488.5,461.7z"
                    />
                </g>
                <g>
                    <path
                        class="letter"
                        d="M593.9,435h7.6l18,46.1l18-46.1h7.6l-21.5,53.4h-8.2L593.9,435z"
                    />
                </g>
                <g>
                    <path
                        class="letter"
                        d="M706.1,435h23.8c9.3,0,15,5.6,15,13.6c0,6.7-4.5,11.2-9.4,12.2c5.7,0.9,10.4,6.7,10.4,13.1c0,8.6-5.7,14.4-15.4,14.4
                        h-24.3V435z M728.7,458.1c6,0,9.2-3.7,9.2-8.6c0-4.8-3.2-8.6-9.2-8.6h-16v17.2H728.7z M729,482.4c6.2,0,9.9-3.5,9.9-9.2
                        c0-4.9-3.4-9.2-9.9-9.2h-16.3v18.4H729z"
                    />
                </g>
                <g>
                    <path
                        class="letter"
                        d="M814.6,445.3v43h-6.6V435h6.8l30.7,42.2V435h6.6v53.4h-6.4L814.6,445.3z"
                    />
                </g>
                <g>
                    <path
                        class="letter"
                        d="M955.5,444l-18.2,44.4h-2.7L916.5,444v44.4h-6.6V435h9.5l16.6,40.6l16.6-40.6h9.5v53.4h-6.6V444z"
                    />
                </g>
                <g>
                    <path
                        class="letter"
                        d="M1028.3,288h6.6v47.4h24.8v5.9h-31.4V288z"
                    />
                </g>
            </g>
            }
        </g>
    </g>
</svg>
}
